import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import Container from '../../layout/Container';
import Button from '../../common/Button';
// Import the hero image
import { heroImage } from '../../../utils/ImageImports';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white overflow-hidden">
      {/* Wave shape at the bottom */}
      <div className="absolute bottom-0 left-0 right-0 w-full">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
          <path 
            fill="#ffffff" 
            fillOpacity="1" 
            d="M0,128L48,133.3C96,139,192,149,288,138.7C384,128,480,96,576,85.3C672,75,768,85,864,106.7C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
      
      <Container className="relative z-10 py-20 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="relative z-20 flex flex-col items-center justify-center text-center -mt-16"
          >
            {/* Added text shadow and position for better visibility */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.2)' }}>
              <span className="block">
                Every Byte Matters
              </span>
            </h1>
            
            {/* Add a semi-transparent background to the paragraph for better readability */}
            <div className="bg-blue-900 bg-opacity-70 p-4 rounded-lg mb-8 backdrop-blur-sm shadow-lg">
              <p className="text-lg md:text-xl text-white">
                Providing comprehensive hardware solutions and IT infrastructure 
                services to optimize your business operations.
              </p>
            </div>
            
            <Button 
              to="/contact" 
              variant="primary" 
              size="lg"
              className="group flex items-center"
            >
              Get in Touch
              <ChevronRight size={20} className="ml-1" />
            </Button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:block"
          >
            {/* Using the actual image instead of a placeholder */}
            <div className="relative">
              <img 
                src={heroImage} 
                alt="Dedicated Support Team" 
                className="w-full max-h-[400px] object-cover rounded-lg shadow-xl"
              />
              
              {/* We can still add some animated elements on top of the image */}
              <motion.div 
                className="absolute -top-10 right-24 w-20 h-20 rounded-lg bg-teal-500 bg-opacity-90 shadow-lg"
                animate={{ 
                  y: [0, -8, 0], 
                  rotate: [0, 3, 0]
                }}
                transition={{ 
                  duration: 5, 
                  repeat: Infinity, 
                  ease: "easeInOut"
                }}
              />
              
              <motion.div 
                className="absolute -bottom-6 left-20 w-16 h-16 rounded-full bg-blue-600 bg-opacity-80 shadow-lg"
                animate={{ 
                  y: [0, 10, 0], 
                  rotate: [0, -5, 0]
                }}
                transition={{ 
                  duration: 7, 
                  repeat: Infinity, 
                  ease: "easeInOut",
                  delay: 1
                }}
              />
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;